import actionReducer from "./actionReducer";
import enumReducer from "./enumReducer";
import errorReducer from "./errorReducer";
import linksMagicLinkReducer from "./linksMagicLinkReducer";
import securityReducer from "./securityReducer";

const userReducer = {
  actionReducer: actionReducer,
  enumReducer: enumReducer,
  errorReducer: errorReducer,
  linksMagicLinkReducer: linksMagicLinkReducer,
  securityReducer: securityReducer
};

export default userReducer;
